import Head from 'next/head';
import Dropdown from '@/components/Dropdown';

const AccordionPage: React.FC = () => {
  return (
    <>
      <Head>
        <title>Dropdown</title>
      </Head>

      <Dropdown />
    </>
  );
};

export default AccordionPage;
